var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoneyIconDot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7082 16C31.7082 24.8366 24.6101 32 15.8541 32C7.09812 32 0 24.8366 0 16C0 7.16344 7.09812 0 15.8541 0C24.6101 0 31.7082 7.16344 31.7082 16Z",
    fill: "#F0F8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4527 18.6557H16.5262C17.2615 18.6557 17.7722 18.1992 17.7722 17.5455C17.7722 16.7988 17.126 16.4584 16.5262 16.4584H16.4527V18.6557Z",
    fill: "#006EF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5666 13.383H15.5124C14.7772 13.383 14.2664 13.8395 14.2664 14.4933C14.2664 15.2399 14.9126 15.5803 15.5124 15.5803H15.5666V13.383Z",
    fill: "#006EF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 23C19.866 23 23 19.866 23 16C23 12.134 19.866 9 16 9C12.134 9 9 12.134 9 16C9 19.866 12.134 23 16 23ZM15.5666 11.5997H16.4527V12.4972H16.5301C17.7064 12.4972 18.6661 13.4565 18.6661 14.6325L18.6622 14.6287H17.7761C17.7761 13.9401 17.215 13.383 16.5301 13.383H16.4527V15.5725H16.5262C17.7645 15.5725 18.6622 16.4043 18.6622 17.5455C18.6622 18.6867 17.7451 19.5416 16.5262 19.5416H16.4527V20.3733H15.5666V19.5416H15.5085C14.3322 19.5416 13.3725 18.5822 13.3725 17.4062H14.2587C14.2587 18.0948 14.8197 18.6519 15.5047 18.6519H15.5666V16.4662H15.5124C14.2741 16.4662 13.3764 15.6345 13.3764 14.4933C13.3764 13.3521 14.2935 12.4972 15.5124 12.4972H15.5666V11.5997Z",
    fill: "#006EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoneyIconDot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MoneyIconDot.1cadbfa38f1805f832cb15b07fbcfe4b.svg";